import { useContext, useMemo } from "react";
import { ConstantContext } from "components/context/ConstantProvider";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";

const TeamSourceField = ({ name, label, ...props }) => {
  const { teamSourceTypes, teamSources } = useContext(ConstantContext);

  const options = useMemo(() => {
    if (!teamSourceTypes || !teamSources) return undefined;

    let result = teamSources.map((teamSource) => {
      const is_active =
        teamSource.type !== "TEAM_MEMBER" || teamSource.user.is_active
          ? ""
          : " (inactive)";
      return [teamSource.id, teamSource.label + is_active];
    });

    return result;
  }, [teamSourceTypes, teamSources]);

  if (!options) return <></>;

  return (
    <ListSelectField
      options={options}
      name={name}
      label={label}
      multiple
      {...props}
    />
  );
};

export default TeamSourceField;
